/**
 * Carga diferida de Google Maps JS API + plugin googlemutant (deja usar el resto
 * del código Leaflet existente sin cambios — markers, clustering, OMS, Draw, etc.).
 * Sin REACT_APP_GOOGLE_MAPS_JS_KEY configurada, cargarGoogleMaps() resuelve false
 * y el mapa cae de vuelta a los tiles gratuitos (CartoDB/OSM/Esri) como siempre.
 */

const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_JS_KEY || '';

// Estilo oscuro estándar de Google ("Night" de la galería pública de estilos) —
// para que el modo "dark" se vea consistente con lo que había con CartoDB dark_all.
export const GOOGLE_DARK_STYLE = [
  { elementType: 'geometry', stylers: [{ color: '#1c2541' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#04080f' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#8892a4' }] },
  { featureType: 'administrative', elementType: 'geometry', stylers: [{ color: '#1c2541' }] },
  { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#0b132b' }] },
  { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#6b7a99' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#1c2541' }] },
  { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#8892a4' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#00c8ff' }, { weight: 0.4 }] },
  { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#0b132b' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#04080f' }] },
];

let cargaPromesa = null;

export function cargarGoogleMaps() {
  if (!GOOGLE_MAPS_KEY) return Promise.resolve(false);
  if (window.google?.maps && window.L?.gridLayer?.googleMutant) return Promise.resolve(true);
  if (cargaPromesa) return cargaPromesa;

  cargaPromesa = new Promise((resolve) => {
    const s1 = document.createElement('script');
    s1.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}`;
    s1.onload = () => {
      const s2 = document.createElement('script');
      s2.src = 'https://unpkg.com/leaflet.gridlayer.googlemutant@0.14.1/dist/Leaflet.GoogleMutant.js';
      s2.onload = () => resolve(true);
      s2.onerror = () => resolve(false);
      document.head.appendChild(s2);
    };
    s1.onerror = () => resolve(false);
    document.head.appendChild(s1);
  });
  return cargaPromesa;
}

/** tipo: 'dark' | 'osm' | 'sat'. Cae a las URLs de tile pasadas si Google no está disponible. */
export function crearCapaBase(tipo, L, urls) {
  const usaGoogle = !!(window.google?.maps && L.gridLayer?.googleMutant);
  if (usaGoogle) {
    if (tipo === 'dark') return L.gridLayer.googleMutant({ type: 'roadmap', styles: GOOGLE_DARK_STYLE, maxZoom: 19 });
    // 'hybrid', no 'satellite' puro — sin calles/nombres de lugares encima la vista
    // satelital no sirve para análisis operacional (imagen sin referencias).
    if (tipo === 'sat') return L.gridLayer.googleMutant({ type: 'hybrid', maxZoom: 19 });
    return L.gridLayer.googleMutant({ type: 'roadmap', maxZoom: 19 });
  }
  const url = tipo === 'dark' ? urls.dark : tipo === 'osm' ? urls.osm : urls.sat;
  const attribution = tipo === 'dark' ? '© CartoDB' : tipo === 'osm' ? '© OSM' : '© Esri';
  return L.tileLayer(url, { attribution, maxZoom: 19 });
}
